import { Outlet } from "react-router-dom";

const SchoolContainer = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default SchoolContainer;
